import React from "react";

function PrivacyPolicy() {
    return (
        <React.Fragment>
            <div className="container w-full mx-auto font-poppins">
                <header className="mx-auto pt-32">
                    <h1 className="text-center text-3xl font-bold text-sky-400">Privacy Policy</h1>
                </header>
                <div className="lg:w-6/12 w-11/12 my-10  flex flex-col lg:p-10 px-8 py-4 justify-center items-center mx-auto bg-slate-800 bg-opacity-50 border-4 border-slate-800 rounded-xl h-max">
                    <ul class="list-disc text-slate-200 flex md:gap-4 gap-3 flex-col md:p-4">
                        <li>User can send more than 1 confession message.</li>
                        <span className="block text-slate-300">(User dapat mengirimkan lebih dari 1 pesan confession.)</span>
                        <li>
                            This website does not collect user's personal data other than what the user sends in the form provided, so the user's identity is not recorded in the database at all. Therefore user privacy is maintained and
                            safe.
                        </li>
                        <span className="block text-slate-300">
                            (Website ini sama sekali tidak mengambil data pribadi user selain apa yang user kirim ke dalam form yang tersedia, jadi identitas user sama sekali tidak terdata di database. Oleh sebab itu privasi user terjaga
                            dan aman.)
                        </span>
                        <li>
                            If in sending this confession message on the myConfession web there are various harsh words in which there is intentional and serious hatred, cursing, or insults, then we will immediately delete them as soon as
                            possible.
                        </li>
                        <span className="block text-slate-300">
                            (Apabila dalam mengirimkan pesan confession di web myConfession ini terdapat berbagai kata kata kasar yang di dalamnya terdapat kebencian, makian, atau hinaan secara sengaja dan serius, maka kami akan langsung
                            menghapusnya sesegera mungkin.)
                        </span>
                        <li>
                            If the user has sent a confession message on the myConfession web, then the user has fully and consciously accepted all possible responsibilities as a result of the confession message. For example, there is
                            hatred that occurs after the message is sent, then myConfession states that it is the user's own responsibility and not the responsibility of the web or creator.
                        </li>
                        <span className="block text-slate-300">
                            (Apabila user telah mengirimkan pesan confession di web myConfession ini maka user telah secara penuh dan sadar akan menerima semua tanggung jawab yang mungkin ada akibat pesan confession tersebut. Contohnya ada
                            kebencian yang terjadi setelah pesan tersebut dikirim, maka myConfession menyatakan bahwa itu adalah tanggung jawab user sendiri dan bukan tanggung jawab milik web maupun creator.)
                        </span>
                    </ul>
                </div>
            </div>
        </React.Fragment>
    );
}
export default PrivacyPolicy;
